<template>
    <div class="famous-pedia-create-form">
        <!-- 1. 生平事迹及批盘讨论切换tab -->
        <div class="famous-pedia-cf-tab dsp-flex">
            <div class="famous-pedia-cf-tab-item" @click="toggleTab(1)">
                <span class="famous-pcti-title" v-bind:class="{'cur': curPediaContentTab == 1}"><span class="big-title">生平事迹</span></span>
            </div>
            <div class="famous-pedia-cf-tab-item" @click="toggleTab(2)">
                <span class="famous-pcti-title" v-bind:class="{'cur': curPediaContentTab == 2}"><span class="big-title">批盘讨论</span><span class="small-title" v-if="curPediaBaziInfo.reply != 0">{{curPediaBaziInfo.reply}}人</span></span>
            </div>
        </div>
        <!-- 2. 生平事迹 -->
        <famous-life-story
            v-if="curPediaContentTab == 1">
        </famous-life-story>
        <!-- 3. 批盘讨论 -->
        <famous-comment-list
            v-if="curPediaContentTab == 2">
        </famous-comment-list>
    </div>
</template>

<script>
import FamousLifeStory from './FamousLifeStory.vue'
import FamousCommentList from '../famouscomment/FamousCommentList.vue'
import { FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'FamousFormRead',
    components: { FamousLifeStory, FamousCommentList },
    computed: {
        curPediaContentTab() {
            return this.$store.state.famouspedia.curPediaContentTab;
        },
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo;
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
        // 绑定滚动联动事件
        FAMOUS_DOM.bindFamousFormScrollEvent(false);
        setTimeout(() => {
            FAMOUS_DOM.bindFamousFormScrollEvent(true);
        }, 1500);
    },
    methods: {
        initDom() {
            var topBarDiv = document.getElementsByClassName('famous-pedia-fate-topbar')[0];
            if(topBarDiv) {
                this.$el.style.paddingTop = topBarDiv.clientHeight + 'px';
                // this.$el.style.paddingBottom = (innerHeight-topBarDiv.clientHeight) + 'px';
            }
        },
        toggleTab(tab) {
            // 重复点击return一下
            if(tab == this.$store.state.famouspedia.curPediaContentTab) {
                return;
            }
            this.$store.state.famouspedia.curPediaContentTab = tab;
            
            // var curScrollYId = this.$store.state.minifatefortune.curScrollYId;
            setTimeout(() => {
                if(tab == 1) {
                    FAMOUS_DOM.updateFamousReadStoryScrollTop('');
                }else if(tab == 2) {
                    FAMOUS_DOM.updateFamousReadCommentScrollTop('');
                }
            }, 20);

            var baikeId = this.$store.state.famouspedia.curPediaBaziId;
            if(tab == 2) {
                this.$store.dispatch('famouspediacomment/setCommentFormData', {
                    formData: {
                        bid: baikeId,
                        f_type: 'all',
                        parentsid: 0,
                        touid: 0
                    }
                })
            }
        }
    }
}
</script>